import { createSelector } from 'reselect';
import {
  entitySelector,
  entitiesSelector,
  entityErrorByKeyword
} from 'helpers/entitySelector';
import _ from 'lodash';

const entityRecommenderEntities = (state) => state.db.entities;
const entityRecommenderResults = (state) => state.db.result;
const entityRecommenderErrors = (state) => state.db.errors;

const getEntityRecommenderSelector = createSelector(
  [entityRecommenderEntities, entityRecommenderResults, entityRecommenderErrors],
  (entities, results, errors)  => {
    const entitiesSuggestion = entitiesSelector(entities, results, 'entitySuggestions'),
          entityRecommendations = entitiesSelector(entities, results, 'entityRecommendations'),
          entitiesWebPages = entitiesSelector(entities, results, 'entitiesWebPages');
          
    let   savedNewClassifier = entitySelector(entities, results, 'savedNewClassifier');

    const errorKeyword = _.isEmpty(results.savedNewClassifier)
          ? 'document_already_exists_exception'
          : results.savedNewClassifier.toString();
    const newClassifierError = entityErrorByKeyword(errors, errorKeyword);
    if (_.has(newClassifierError, 'message'))
      savedNewClassifier = Object.assign({hasError: true}, newClassifierError);

    return {
      entitiesSuggestion,
      entityRecommendations,
      entitiesWebPages,
      savedNewClassifier,
      errors
    };
  }
);

export default getEntityRecommenderSelector;



// WEBPACK FOOTER //
// ./src/components/entityRecommender/entityRecommender.selector.jsx